import {List, styled} from '@mui/material'
import {useI18n} from 'store/Store'
import Accordion from 'components/Display/Accordion'

const ListSettingsItem = ({
    itemName,
    items,
    itemComponent,
    useSaveItemMutation,
    Icon,
    isMobile,
}) => {
    const {i18n} = useI18n()

    return (
        <StyledAccordion title={i18n.t(`settings.${itemName}`)} Icon={Icon}>
            <Content isMobile={isMobile}>
                <Details>
                    <List dense style={{direction: 'rtl'}}>
                        {items?.map((item) => itemComponent(item))}
                    </List>
                </Details>
            </Content>
        </StyledAccordion>
    )
}

export default ListSettingsItem

const StyledAccordion = styled(Accordion)`
    /* margin-bottom: 24px; */
`

const Content = styled('div')`
    display: flex;
    flex-direction: ${({isMobile}) => (isMobile ? 'column' : 'row')};
    width: 100%;
`

const Details = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 2;
    padding: 24px;
`
